var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#2B5DEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 56.9941H513V284.994H0V56.9941Z",
    fill: "#FFDF29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 85.4941H513V256.494H0V85.4941Z",
    fill: "#D70000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 97.6922V244.296C321.651 244.296 354.198 195.447 378.651 170.994C354.198 146.541 321.651 97.6922 256.5 97.6922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 97.6922C199.5 97.6922 158.802 146.541 134.349 170.994C158.802 195.447 199.5 244.296 256.5 244.296V97.6922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.391 144.945H209.361V196.986H197.391V144.945ZM226.974 144.945H238.944V196.986H226.974V144.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.346 144.945H284.316V196.986H272.346V144.945ZM301.929 144.945H313.899V196.986H301.929V144.945Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSz);
export default __webpack_public_path__ + "static/media/SZ.e1dcf4576c6cfc72968a7052a8be6f47.svg";
export { ForwardRef as ReactComponent };